import React from "react";
import { Provider } from 'appRedux/context';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import App from "./containers/App/index";
// import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { GlobalDebug } from "util/remove-consoles";
require("dotenv").config();
// console.log("ENV",process.env)

const NextApp = () => {
  React.useEffect(() => {
    process.env.NODE_ENV === "production" && GlobalDebug(false);
  }, []);

  return (
    <BrowserRouter>
      <Provider>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </Provider>
    </BrowserRouter>
  );
};

export default NextApp;
